export default __webpack_public_path__ + "static/media/03.73d15298.jpg";